import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog'
import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core'
import { GlobalMessageType } from '@spartacus/core'
import { finalize } from 'rxjs/operators'
import { SharedValue } from '../../../../../models/enum/shared.enum'
import { IHistoryList } from '../../../../../models/interface/history-list.interface'
import { ISharedPagination } from '../../../../../models/interface/shared.interface'
import { BusinessUnitService } from '../../../../../services/business-unit.service'
import { CustomGlobalMessageService } from '../../../../../services/shared/custom-global-message/custom-global-message.service'
import { CustomTableColumnType } from '../../../../shared/custom-components/custom-table/modals/enum/custom-table.enum'
import {
  ICustomTableColumn,
  ICustomTableHeader
} from '../../../../shared/custom-components/custom-table/modals/interface/custom-table.interface'

@Component({
  selector: 'app-dispenser-end-customer',
  templateUrl: './dispenser-end-customer.component.html',
  styleUrls: ['./dispenser-end-customer.component.scss'],
  standalone: false
})
export class DispenserEndCustomerComponent implements OnInit {
  public businessId: string
  public showInitialLoader = true
  public showLoaderOnPagination: boolean
  public units: IHistoryList
  public inputSearch: string

  public headers: ICustomTableHeader[] = [
    { title: 'priceSupportAgreement.endUserNumber' },
    { title: 'priceSupportAgreement.endUserName' },
    { title: 'priceSupportAgreement.postCode' },
    { title: 'priceSupportAgreement.state' },
    { title: 'priceSupportAgreement.addressLine1' },
    { title: 'priceSupportAgreement.addressLine2' },
    { title: '', type: CustomTableColumnType.BUTTON, cssStyle: 'min-width: 67px' }
  ]

  public columns: ICustomTableColumn[] = [
    { key: 'uid' },
    { key: 'name' },
    { key: 'shippingAddress.postalCode' },
    { key: 'shippingAddress.town' },
    { key: 'shippingAddress.line1' },
    { key: 'shippingAddress.line2' },
    {
      key: 'selectUser',
      type: CustomTableColumnType.BUTTON,
      button: {
        title: 'Select',
        handler: (res) => this.selectUnit(res)
      }
    }
  ]

  constructor(
    public businessUnitService: BusinessUnitService,
    private changeDetectorRef: ChangeDetectorRef,
    public globalMessageService: CustomGlobalMessageService,
    @Inject(DIALOG_DATA) public data: any,
    private dialogRef: DialogRef<DispenserEndCustomerComponent>
  ) {}

  ngOnInit(): void {
    this.inputSearch = this.businessId
    this.businessUnitService.getEndUnits({ searchText: this.businessId }).subscribe((res) => {
      this.units = res
      this.showInitialLoader = false
      this.changeDetectorRef.detectChanges()
    })
  }

  public get showMessageWhenNoData(): boolean {
    return !this.showInitialLoader && !this.showLoaderOnPagination
  }

  public get showLoaderOnStartupOrWhenNoData(): boolean {
    return this.showInitialLoader || (!this.units?.results?.length && this.showLoaderOnPagination)
  }

  public pageChange(value: number): void {
    this.changePageData({
      pageNumber: value
    })
  }

  public changePageData(params?: ISharedPagination): void {
    this.showLoaderOnPagination = true
    this.businessUnitService
      .getEndUnits(params)
      .pipe(
        finalize(() => {
          this.showLoaderOnPagination = false
          this.changeDetectorRef.detectChanges()
        })
      )
      .subscribe((res) => {
        if (!res) {
          this.globalMessageService.add(SharedValue.errorTryAgain, GlobalMessageType.MSG_TYPE_ERROR)
        } else {
          this.units = res
        }
      })
  }

  public onSearch(text: string): void {
    text = text?.trim()
    if (text) {
      this.changePageData({ searchText: text })
    } else {
      this.changePageData()
    }
  }

  public selectUnit(value: any): void {
    if (value) {
      this.dialogRef.close(value)
    }
  }

  public closeModal(): void {
    this.dialogRef.close()
  }
}
